<p-dialog
  (onHide)="closeDialog()"
  [dismissableMask]="true"
  position="top"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayDialog"
  [responsive]="true"
  [style]="{'width':widthDialog}"
  [modal]="true"
  appendTo="body"
>

  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-utensils yoni-color"></i> Fiche Technique : {{infosMenuCompoSupplier?.menuCompo.produitDeclinaisonLibelle}}
    </div>
  </ng-template>

  <div class="row">

    <div class="col" style="min-width:520px;">
      <div class="row">
        @if (infosMenuCompoSupplier) {
          <div class="col-md-7">
            <yo-img-entity
              [entityId]="infosMenuCompoSupplier.menuCompo.produitId"
              [entityName]="produitsSvc.getEntityName()"
              [height]="280"
              format="regular"
              [refresh]="refreshImage"
              [displayNoImage]="false"
              [title]="infosMenuCompoSupplier.menuCompo.produitDeclinaisonLibelle"
              [ordre]="1"></yo-img-entity>
          </div>
        }
        <div class="col-md-5 mg-t-10">
          <div class="row">
            <div class="col-md-12">
              <strong class="cursor "
                      (click)="openDetailsProduit(infosMenuCompoSupplier?.menuCompo.fabrique,infosMenuCompoSupplier?.menuCompo.produitId)">
                <yo-icon-produitfab [fabrique]="infosMenuCompoSupplier?.menuCompo.fabrique"></yo-icon-produitfab>
                {{infosMenuCompoSupplier?.menuCompo.produitDeclinaisonLibelle | uppercase}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label class="badge-color">Prestation</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.cellule.libelleConvive}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label class="badge-color">Jour</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.cellule.dateMenu | date:'E d LLL yyyy' | titlecase}}</strong>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color">Repas</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.cellule.libelleRepas}}</strong>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color">Composante</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.cellule.libelleDecoupageRepas}}</strong>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color">Déclinaison</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.menuCompo.declinaisonLibelle}}</strong>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color">Prix d'achat</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.menuCompo.udpPdPrixAchat | currency:'EUR':'symbol':'1.4-4'}} / portion</strong>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color">Effectif Prévu</label>
            </div>
            <div class="col-md-9">
              <strong>{{infosMenuCompoSupplier?.menuCompo.effectifPrevu}} pers.</strong>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color mg-r-2">
                Allergènes
              </label>

            </div>
            <div class="col-md-9">
              <ng-template *ngTemplateOutlet="tplAllergenes;context:{menuCompo:infosMenuCompoSupplier?.menuCompo}"></ng-template>
            </div>
          </div>
          <div class="row ">
            <div class="col-md-3">
              <label class="badge-color">Appellations</label>
            </div>
            <div class="col-md-9">
              <ng-template *ngTemplateOutlet="tplAppellations;context:{menuCompo:infosMenuCompoSupplier?.menuCompo}"></ng-template>
            </div>
          </div>
        </div>
    </div>
      </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <p-tabView (activeIndexChange)="activeIndexChange($event)" [(activeIndex)]="activeIndex">
        <p-tabPanel header="Composants">
          <ng-template
            *ngTemplateOutlet="tplIngredients;context:{menuCompo:infosMenuCompoSupplier?.menuCompo, ingredients:ingredients}"></ng-template>
        </p-tabPanel>
        <p-tabPanel header="Apports nutritionnels">
          <ng-template
            *ngTemplateOutlet="tplApportsNutris;context:{menuCompo:infosMenuCompoSupplier?.menuCompo}"></ng-template>
        </p-tabPanel>
        <p-tabPanel header="Mode opératoire">
          @if (infosMenuCompoSupplier?.menuCompo.modeOperatoire) {
            <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(infosMenuCompoSupplier?.menuCompo.modeOperatoire)">
            </p>
          }
          @else {
            Aucun mode opératoire renseigné.
          }
        </p-tabPanel>
        <p-tabPanel header="Familles diététiques">
          <ng-template *ngTemplateOutlet="tplFamillesGemrcn;context:{menuCompo:infosMenuCompoSupplier?.menuCompo}"></ng-template>
        </p-tabPanel>
        <p-tabPanel header="Aller sur la fiche technique" leftIcon="fas fa-arrow-circle-right"
                    tooltip="Voir la fiche technique">
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>

  <!--TEMPLATE INGREDIENTS-->
  <ng-template #tplIngredients let-menuCompo="menuCompo" let-ingredients="ingredients">

    @if (utils.isCollectionNullOrEmpty(ingredients)) {
      Aucun ingrédient.
    }

    @if (!utils.isCollectionNullOrEmpty(ingredients)) {
      @for (ing of ingredients; track ing.produitUtilise.produit.id) {
        @if(!ing.actif) {
          <i class="width-25 fas fa-exclamation-triangle text-warning cursor"
             title="La denrée est inactive"></i>
        }
        <a class="ingLinks cursor"
           (click)="openDetailsProduit(ing.produitUtilise.fabrique,ing.produitUtilise.produit.id)">
          <yo-icon-produitfab [fabrique]="ing.produitUtilise.fabrique"></yo-icon-produitfab>
          {{ing.produitUtilise.libelle}}</a><br/>
      }
    }

  </ng-template>


  <!--TEMPLATE FAMILLES GEMRCN-->
  <ng-template #tplFamillesGemrcn let-menuCompo="menuCompo">

    @if (utils.isCollectionNullOrEmpty(famillesGemrcn)) {
      Aucune.
    }

    @if (!utils.isCollectionNullOrEmpty(famillesGemrcn)) {
      @for (fnp of menuCompo.familleNutritionnelleProduitDTOList; track fnp.id) {
        <yo-famille-gemrcn [familleNutri]="menuCompoSvc.getFamilleNutri(fnp)" [displayLabel]="true"></yo-famille-gemrcn>
      }
    }

  </ng-template>

  <!--TEMPLATE APPELLATIONS-->
  <ng-template #tplAppellations let-menuCompo="menuCompo">

    @if (utils.isCollectionNullOrEmpty(produitAppellations)) {
      Aucune.
    }

    @if (!utils.isCollectionNullOrEmpty(produitAppellations)) {
      <span class="mg-r-2">
          {{labelAppellations()}}
        </span>
    }

  </ng-template>


  <!--TEMPLATE ALLERGENES-->
  <ng-template #tplAllergenes let-menuCompo="menuCompo">

    @if (utils.isCollectionNullOrEmpty(produitAllergenes)) {
      Aucun.
    }

    @if (!utils.isCollectionNullOrEmpty(produitAllergenes)) {
      <span class="mg-r-2">
          {{labelAllergenes()}}
        </span>
    }

  </ng-template>

  <!--TEMPLATE APPORTS NUTRIS-->
  <ng-template #tplApportsNutris let-menuCompo="menuCompo">

    <div class="row">
      <div class="col-md-6 col-md-auto">
        @if (kcalPortion > 0) {
          <p-table [columns]="cols" [value]="apportsNutritionnels">

          <!--COLGROUP-->
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for (col of columns; track col.field) {
                @switch (col.field) {
                  @case ('libelle') {
                    <col [style.width]="'200px'" [style.text-align]="'left'">
                  }
                  @default {
                    <col [style.width]="'155px'" [style.text-align]="'right'">
                  }
                }
              }
            </colgroup>
          </ng-template>

          <!--HEADER-->
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col.field) {
                <th>
                  @switch (col.field) {
                    @case ('teneurPortion') {
                      {{col.header}} ({{getQuantitePortion(produitDeclinaison).toFixed(2)}} g)
                    }
                    @default {
                      {{col.header}}
                    }
                  }
                </th>
              }
            </tr>
          </ng-template>

          <!--BODY-->
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col.field) {
                @switch (col.field) {
                  @case ('libelle') {
                    <td>
                      {{rowData.libelle}}
                    </td>
                  }
                  @case ('teneur100g') {
                    <td class="text-right">
                      {{getTeneur(produitApportsNutris,rowData)}} g
                    </td>
                  }
                  @case ('teneurPortion') {
                    <td class="text-right">
                      {{getDisplayedQuantite(produitDeclinaison,rowData,produitApportsNutris)}} g
                    </td>
                  }
                }
              }
            </tr>
          </ng-template>
        </p-table>
        }
      </div>
      <div class="col-md-6 col-md-auto">
        @if (kcalPortion && kcalPortion > 0) {
          <div class="row">
            <div class="col-md-12 text-center">
              <span class="kcalPortion">{{getKcalPortionLabel()}}</span>
            </div>
          </div>
        }
        @if (kcalPortion > 0) {
          <div class="row">
            <div class="col-md-12 center-chart-compo">
            <dx-pie-chart
              id="apportsNutrisGraph"
              title="Apports nutritionnels"
              palette="bright"
              [dataSource]="apportsNutriGraphData"
            >
              <dxo-legend
                orientation="horizontal"
                itemTextPosition="right"
                horizontalAlignment="center"
                verticalAlignment="bottom"
                [columnCount]="4"
              ></dxo-legend>
              <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
              <dxo-export [enabled]="true"></dxo-export>
              <dxi-series argumentField="label" valueField="value">
                <dxo-label
                  [visible]="true"
                  position="columns"
                >
                  <dxo-font [size]="16"></dxo-font>
                  <dxo-connector [visible]="true" [width]="0.5"></dxo-connector>
                </dxo-label>
              </dxi-series>
            </dx-pie-chart>
          </div>
          </div>
        }
      </div>
    </div>
    @if (!kcalPortion || kcalPortion === 0) {
      <div class="row">
        <div class="col-md-12 text-center">
          <span class="kcalPortion">Aucune donnée nutritionnelle renseignée.</span>
        </div>
      </div>
    }
  </ng-template>

</p-dialog>


